enum FilterType {
  String = 'string',
  Date = 'date',
  Number = 'number',
  Search = 'search',
}

export default FilterType;
